<!--
  功能：自选股策略详情页(产品1部)
  作者：wangwenhao
  邮箱：wangwenhao@gw.com.cn
  时间：2025-06-26 14:35:39
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
	<div :class="$route.query.themeStyleVs == '2' ? 'black_theme hot_page' : 'themeWhite hot_page'">
		<header id="hdMain" :class="mainScrollShow ? 'sticky_header' : ''">
			<div class="header_main">
				<div class="navg_box" :style="`backdrop-filter: blur(${filterNum}px)`">
					<div class="bg_box">
						<navigation :text="'策略详情'" :searchShow="true" :reloadImgShow="true"></navigation>
					</div>
					<!-- 切换 -->
					<div class="tab_switch" v-if="compareVersions(version, '10.07')">
						<span class="tab_switch_text" :class="activeInfo == 0 ? 'switch_active' : ''"
							@click="tabSwitchFunc(0)">自选股</span>
						<span class="tab_switch_text left30" :class="activeInfo == 1 ? 'switch_active' : ''"
							@click="tabSwitchFunc(1)">持仓股</span>
					</div>
				</div>

				<!-- 标题,描述 -->
				<div class="head">
					<div class="title" v-if="!compareVersions(version, '10.07')">{{ titleText }}</div>
					<div class="desc">
						{{ descText }} <span class="head-desc-but" @click="gotoDescUrl()"> 查看详情 >> </span>
					</div>
				</div>
			</div>
		</header>
		<!-- 详情 -->
		<div class="main contant_main">
			<!-- 组件:T0记录,信号池 -->
			<hedgingRecord :yunToken="yunToken" :activeInfo="activeInfo"></hedgingRecord>

			<div class="mod">
				<div class="mod-title-flex" >
					<div class="mod-hd">
						<span>策略分析</span>
					</div>
					<div class="title-flex-right" >
						数据更新于 {{ formatDateToStr(lastDate,'-') }}
					</div>
				</div>

				<div class="mod-bd clfx">
					<div class="info">
						本策略自运行以来，为您排除了<em class="green">{{ HedgeCount }}</em>次风险
						<span v-show="AlphaCount > 0">
							，捕捉了<em class="red">{{ AlphaCount }}</em>次机会
						</span>
						<span v-show="cumulative > 0">
							，近一周累计为您创造了<em class="red">{{ cumulative }}%</em>的超额收益</span>。
					</div>
					<div class="card flex">
						<div class="item" v-if="HedgeCount > 0">
							<div>
								<b class="font-green">{{ HedgeCount }}</b>
								<em class="font-green">次</em>
								<sup class="green">预警</sup>
							</div>
							<div v-if="HedgeCount > 0" :class="AlphaCount > 0 ? '' : 'item-list'">
								<p v-for="(itemHed, indexHed) in HedgeStats" :key="indexHed"
									:class="HedgeStats.length > 1 ? 'flex-w50' : 'flex-w100'">
									<span v-for="(itemI, indexI) in itemHed" :key="indexI" class="item-list-span">
										⚠️ {{ indexI }}: {{ itemI }}次
									</span>
								</p>
							</div>
						</div>
						<div class="item" v-if="AlphaCount > 0">
							<div>
								<b class="font-red">{{ AlphaCount }}</b>
								<em class="font-red">次</em>
								<sup class="red">增强</sup>
							</div>
							<div v-if="AlphaCount > 0" :class="HedgeCount > 0 ? '' : 'item-list'">
								<p v-for="(itemAlp, indexAlp) in AlphaStats" :key="indexAlp">
									<span v-for="(itemA, indexA) in itemAlp" :key="indexA">
										👍 {{ indexA }}: {{ itemA }}次
									</span>
								</p>
							</div>
						</div>
					</div>


				</div>
			</div>

			<!-- 折线图 -->
			 <div  class="mod" >
				<hedgingZline
					:todayProfit="todayProfit"
					:totalRate="totalRate"
					:yearRate="yearRate"
					:maxRetreatRate="maxRetreatRate"
					:dailyRateList="dailyRateList"
					:policyRateList="policyRateList"
					:activeInfo="activeInfo"
					:dateList="dateList"
					:top3List="top3List"
					:dailyRateLast="dailyRateLast"
				 ></hedgingZline>
			 </div>

			<div class="tips">
				风险提示：服务存在策略失效风险及市场波动风险。策略模型可能因数据偏差、参数失效、市场环境变化等因素导致不及预期。本服务不涉及投资咨询服务，所示信息仅供参考，不构成投资建议，您需独立判断，谨慎决策，并自行承担投资风险。
			</div>
		</div>

		<!-- 底部按钮 -->
		<div class="fixed-button" v-if="mndsopenswitch">
			<van-badge v-if="isJoin" class="rank-btn-log">
				<span class="join-btn rank-btn" @click="gotoMnUrl()">总收益:
					<div :class="[judgeColor(dsInfo.totalRisk)]" style="margin-right: 10px">
						{{ dsInfo.totalRisk == 0 ? '--' : toFixedNum(dsInfo.totalRisk * 100, 2, '%') }}
					</div>
					排名:{{ dsInfo.totalRank == 0 ? '--' : dsInfo.totalRank }}
				</span>
				<template #content>
					<div class="log-content">我的比赛</div>
				</template>
			</van-badge>
			<van-badge v-else class="ds-btn">
				<span class="join-btn" @click="gotoMnUrl()">参加模拟比赛</span>
				<template #content>
					<div class="log-content">领现金奖</div>
				</template>
			</van-badge>

			<span style="color: #fff !important" :class="isJoin ? 'ds-sp-btn' : 'join-sp-btn'"
				@click="gotoSpUrl()">实盘交易</span>
		</div>

		<div class="fixed-button" v-else>
			<span style="color: #fff !important" @click="gotoSpUrl()" class="sp-btn-info">实盘交易</span>
		</div>
	</div>
</template>

<script>
import {
	getFactorDetail,
	getYunToken,
	getProfitStrategy,
	getHedgingBackTest,
	getHistoryPages,
	getHedgindSim,
	myDsInfo
} from '@/api/hedging.js';

import {
	judgeColor,
	toFixedNum,
	dateFormat,
	formatDateToStr,
	formatTimeToStr,
	cleanStockCode,
	compareVersions
} from '@/utils/format';

export default {
	name: '',
	data() {
		return {
			// 计算头部透明以及半透明
			mainScrollShow: false,
			filterNum: 0,
			activeInfo: 0,
			// 标题与描述
			titleText: window.hedging_title,
			descText: window.hedging_desc,
			//   详情内容
			isExpanded: false,
			zxgList: [], // 自选股列表
			inOutList: [], // 调入调出记录
			lastout: '',
			zxgStocks: [],
			page: 0,
			count: 3,
			lastId: '',
			showExpand: true,
			// 股票信息
			socket: null,
			// 云Token
			yunToken: '',
			dzhyunObj: null,
			// 避险统计数据
			HedgeStats: [],
			HedgeCount: 0,
			// 增强统计数据
			AlphaStats: [],
			AlphaCount: 0,
			// 因子数据
			factorList: [],
			// 自选股分组id
			groupid: '',

			// 图表数据
			zxgYShaft: [], // Y轴数据
			optimizerYShaft: [], //Y轴数据
			linXShaft: [], // X轴数据
			cumulative: 0, // 累计收益(调优后-调优前)
			zxgInterest: 0,
			optInterest: 0,
			// 画布
			showCanvas: false,
			showCanvas2: true,
			// loading 加载
			stockLoading: true,
			// 版本号
			version: '',
			// 自选股 T+0数据
			t0Profits: [],
			t0YShaft: [],
			t0Interest: '',

			// 增强数据
			profits: [],
			zqYShaft: [],
			zqInterest: '',
			t0openswitch: window.t0openswitch,
			// 是否参赛
			isJoin: false,
			// 大赛信息
			dsInfo: {},
			// 敏感度设置
			levelStatus: null,
			// 模拟大赛按钮开关
			mndsopenswitch: window.mndsopenswitch,
			// T0收益分析展示数据
			lastDate:'',
			// 今日收益率、累计收益率、年化收益率和最大回撤,以及折线图数据
			todayProfit: '', // 今日收益
			totalRate: '', // 累计收益
			yearRate: '', //年化收益率
			maxRetreatRate: '', //最大回撤
			dailyRateList: [], // 日收益率
			policyRateList: [], // 策略收益率
			dateList: [], // 日期列表
			top3List:[],
			dailyRateLast:'',
		};
	},
	filters: {},
	// 侦听器
	watch: {},
	/**
	 * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
	 */
	created() {
		// console.log('$route.query.themeStyleVs', this.$route.query.themeStyleVs);
		this.groupid = this.$route.query.groupid;
		this.activeInfo = this.$route.query.acIndex ? this.$route.query.acIndex : 0;
		this.version = this.$route.query.version ? this.$route.query.version : '9.0';
		window.addEventListener('scroll', this.allPageScroll, true);
		this.getYunTokenFunc();
		this.initRequestFunc();
		// 查询大赛信息
		this.getDsCldsInfo();
	},
	/**
	 * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
	 * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
	 */
	mounted: function () { },
	destroyed() { },
	closeWebSocket() {
		window.removeEventListener('scroll', this.allPageScroll, true);
	},
	// 组件方法
	methods: {
		judgeColor,
		toFixedNum,
		dateFormat,
		formatDateToStr,
		formatTimeToStr,
		cleanStockCode,
		compareVersions,
		// 初始化请求状态
		initRequestFunc: function () {
			var _this = this;
			// 初始化数据
			_this.zxgList = [];
			_this.inOutList = [];
			_this.lastout = '';
			_this.zxgStocks = [];
			_this.HedgeStats = [];
			_this.HedgeCount = 0;
			_this.AlphaStats = [];
			_this.AlphaCount = 0;
			_this.lastId = '';
			_this.page = 0;
			_this.showExpand = true;
			// 折线图数据初始化
			_this.zxgYShaft = [];
			_this.optimizerYShaft = [];
			_this.t0YShaft = [];
			_this.zqYShaft = [];
			_this.linXShaft = [];
			_this.cumulative = 0;
			_this.zxgInterest = 0;
			_this.optInterest = 0;
			_this.t0Interest = 0;
			_this.zqInterest = 0;
			// 初始化T0折线图
			_this.todayProfit = ''; // 今日收益
			_this.totalRate = ''; // 累计收益
			_this.yearRate = ''; //年化收益率
			_this.maxRetreatRate = ''; //最大回撤
			_this.dailyRateList = []; // 日收益率
			_this.policyRateList = []; // 策略收益率
			_this.dateList = []; // 日期列表
			_this.top3List = [];
			_this.dailyRateLast = ''; // 累计收益

			// 导航条移动到最顶部
			document.documentElement.scrollTop = 0;

			if (this.activeInfo == 1) {
				_this.descText = window.ccg_desc;
				// 获取统计数据
				this.getHedgingCountFunc(2);
			} else {
				_this.descText = window.hedging_desc;
				// 获取统计数据
				this.getHedgingCountFunc(1);
			}
		},

		// 全屏滚动监听
		allPageScroll: function () {
			let that = this;
			var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			let topHeight = document.querySelector('#hdMain').offsetHeight;
			let contantMainTop = document.querySelector('.contant_main').offsetTop;
			let navgBoxH = document.querySelector('.navg_box').offsetHeight;
			this.filterNum = (scrollTop / (contantMainTop / 6)).toFixed(2);
			if (scrollTop >= topHeight - navgBoxH) {
				that.mainScrollShow = true;
			} else {
				that.mainScrollShow = false;
			}
		},

		// tab 切换
		tabSwitchFunc: function (index) {
			this.activeInfo = index;
			this.initRequestFunc();
		},

		// 获取云Token
		getYunTokenFunc: function () {
			var _this = this;
			var params = {
				appid: window.cloud.AppId,
				secret_key: window.cloud.SecretKey
			};
			getYunToken({})
				.then((result) => {
					if (result.err == 200) {
						_this.yunToken = result.data;
					}
				})
				.catch((err) => { });
		},
		// 获取增强必避险统计
		getHedgingCountFunc: function (type) {
			var _this = this;
			getProfitStrategy({ type: type })
				.then((result) => {
					// console.log('result', result);
					if (result.err == 200) {
						// 数据获取成功
						if (result.data.length === 0) {
							_this.HedgeStats = [];
							_this.HedgeCount = 0;
							_this.AlphaStats = [];
							_this.AlphaCount = 0;
							_this.t0Profits = [];
							_this.profits = [];
						} else {
							// 避险数据
							_this.HedgeStats = result.data.counts.alarm1 ? result.data.counts.alarm1 : [];
							_this.HedgeCount = result.data.counts.alarm1
								? result.data.counts.alarm1.reduce((sum, item) => {
									const value = Object.values(item)[0]; // 每个对象的值
									return sum + value;
								}, 0)
								: 0;
							// 增强数据
							_this.AlphaStats = result.data.counts.alarm2 ? result.data.counts.alarm2 : [];
							_this.AlphaCount = result.data.counts.alarm2
								? result.data.counts.alarm2.reduce((sum, item) => {
									const value = Object.values(item)[0]; // 每个对象的值
									return sum + value;
								}, 0)
								: 0;
							// 因子数据
							_this.factorList = result.data.factorIds;
							if (_this.activeInfo !== 1) {
								// 存储T+0及增强收益数据
								_this.t0Profits = result.data.t0Profits ? result.data.t0Profits : [];
								_this.profits = result.data.profits ? result.data.profits : [];
							}
						}

						// 处理折线图数据以及更新时间
						// 更新时间
						_this.lastDate = result.data.lastDate;
						// 今日收益率、累计收益率、年化收益率和最大回撤；,折线图数据
						_this.todayProfit = result.data.todayProfit; // 今日收益
						_this.totalRate = result.data.totalRate; // 累计收益
						_this.yearRate = result.data.yearRate; //年化收益率
						_this.maxRetreatRate = result.data.maxRetreatRate; //最大回撤
						_this.dailyRateList = result.data.dailyRateList ? result.data.dailyRateList : []; // 日收益率
						_this.policyRateList =  result.data.policyRateList ? result.data.policyRateList : []; // 策略收益率
						_this.dateList = result.data.dateList ? result.data.dateList : []; // 日期列表
						_this.dailyRateLast = result.data.dailyRateLast;
						// 股票数据
						_this.top3List =  result.data.top3List ? result.data.top3List : [];

					}
				})
				.catch((err) => { });
		},


		// 跳转去实盘
		gotoSpUrl: function () {
			window.location.href = window.hedging_shoping_sp;
		},
		// 跳转去模拟交易
		gotoMnUrl: function () {
			window.location.href = window.mndsurl;
			// this.$toast('敬请期待');
		},
		// 点击跳详情
		gotoDescUrl: function () {
			if (this.activeInfo == 1) {
				window.location.href = window.ccg_desc_url;
			} else {
				window.location.href = window.hedging_desc_url;
			}
		},

		// 查询参赛信息
		getDsCldsInfo: function () {
			var _this = this;
			myDsInfo({})
				.then((result) => {
					console.log('result', result);
					if (result.err == 200) {
						if (result.data.isReg == 1) {
							_this.isJoin = true;
							_this.dsInfo = result.data.userDsInfo[0];
						} else {
							_this.isJoin = false;
						}
					} else {
						_this.isJoin = false;
					}
				})
				.catch((err) => {
					_this.isJoin = false;
				});
		}
	}
};
</script>

<style scoped lang="less">
em {
	font-weight: normal;
	font-style: normal;
}

.flex {
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-flex-wrap: nowrap;
	-ms-flex-wrap: nowrap;
	flex-wrap: wrap;
}

.flex-item {
	-webkit-flex: 1;
	-ms-flex: 1;
	flex: 1;
}

.flex-space-between {
	justify-content: space-between;
}

.flex-wrap {
	flex-wrap: wrap;
}

.navget_main {
	color: #fff;
}

.hot_page {
	width: 100%;
	height: 100%;
	-webkit-overflow-scrolling: touch;

	.sticky_header {
		.navg_box {
			// background: linear-gradient(198.51deg, #4478ff -5%, rgba(239, 242, 250, 1) 95%);
			// padding-top: 0;
			background: url('../../assets/image/blockImg/bg.png') no-repeat;
			background-size: 100%;

			.bg_box {
				width: 100%;
				height: 100%;
				padding-top: 44px;
				// background: url('../../assets/image/detail_top.png') top no-repeat;
				// background-size: 100% 170px;
			}
		}
	}

	.navg_box {
		width: 100%;
		padding-top: 0px;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999999999;

		.bg_box {
			padding-top: 44px;
		}
	}

	header {
		width: 100%;
		background: linear-gradient(198.51deg, #4478ff -6.42%, rgba(239, 242, 250, 0.4) 83.87%);

		.header_main {
			padding-top: 88px;
			background: url(../../assets/image/detail_top.png) no-repeat;
			background-size: 56vh;

			.tab_switch {
				padding: 0 16px;
				margin-bottom: 10px;
				height: 30px;
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				align-content: center;
				justify-content: flex-start;
				align-items: center;
				position: relative;

				.left30 {
					margin-left: 30px;
				}

				.tab_switch_text {
					// color:#2e3748;
					color: #e4e9fe;
					font-size: 16px;
					position: relative;
				}

				.switch_active {
					font-weight: 500;
				}

				.switch_active::before {
					content: '';
					width: 8px;
					height: 3px;
					background: #e4e9fe;
					border-radius: 88px;
					position: absolute;
					/* 让 ::before 参照此元素定位 */
					bottom: -5px;
					/* 控制距离文字底部的距离 */
					left: 50%;
					transform: translateX(-50%);
					transition: all 0.2s ease;
				}
			}
		}
	}

	//   标题,描述
	.head {
		padding: 0 16px 30px;
		margin-top: 40px;

		.title {
			color: #e4e9fe;
			font-size: 22px;
			font-weight: 500;
			margin: 10px 0 0 0;
			line-height: 31px;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			/* 设置文本行数限制,兼容不同浏览器 */
			-webkit-line-clamp: 2;
			line-clamp: 2;
			overflow: hidden;
		}

		.desc {
			color: #e4e9fe;
			font-size: 13px;
			margin: 6px 0 0 0;
			line-height: 31px;
			text-align: justify;
			line-height: 20px;
			// display: -webkit-box;
			-webkit-box-orient: vertical;
			// -webkit-line-clamp: 3;
			overflow: hidden;

			.head-desc-but {
				// color: #517acd;
				color: #e4e9fe;
				float: right;
			}
		}
	}

	//   内容
	.main {
		border-radius: 20px 20px 0 0;
		background-color: #0c0f13;
		margin-top: -17px;
		padding-bottom: 72px;
		overflow: hidden;

		.mod {
			background-color: #181a23;
			padding: 14px 16px;
			margin-top: 8px;

			&:first-child {
				margin-top: 0;
			}

			.mod-title {
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				align-content: center;
				justify-content: space-between;
				align-items: center;

				.mod-but {
					.mod-but-text {
						font-size: 12px;
						color: #3b85fe;
					}
				}
			}

			.mod-title-flex {
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				align-content: center;
				justify-content: space-between;
				align-items: center;
				.title-flex-right {
					font-size:12px;
					color:#949da8;
				}
			}

			.mod-hd {
				&::before {
					content: '';
					display: inline-block;
					vertical-align: middle;
					width: 3px;
					height: 10px;
					background-color: #3b85fe;
					border-radius: 88px;
					margin-right: 4px;
				}

				span {
					vertical-align: middle;
					line-height: 22px;
					color: #e4e9fe;
					font-size: 16px;
					font-weight: 600;
				}

				em {
					vertical-align: middle;
					color: #aab9d1;
					font-size: 12px;
				}
			}

			.stockList {
				min-height: 30px;
			}
		}

		.table {
			margin-top: 12px;

			.thead {
				.th {
					color: #6b7687;
					font-size: 12px;
					text-align: right;
				}
			}

			.tbody {
				.tr {
					position: relative;
					align-items: center;
					height: 53px;

					&.mask {

						.td,
						.fcly {
							filter: blur(6px);
							overflow: initial;
						}
					}

					.lock {
						display: flex;
						justify-content: flex-end;
						align-items: center;
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;

						span {
							display: inline-flex;
							align-items: center;
							justify-content: center;
							padding: 0 14px;
							height: 25px;
							background: #272935;
							border: 1px solid #3b85fe;
							border-radius: 88px;
							color: #3b85fe;
							font-size: 12px;
							white-space: nowrap;
						}
					}

					.td {
						text-align: right;
						overflow: hidden;

						span {
							display: block;
							font-size: 15px;
							color: #e4e9fe;
							font-weight: 500;
							line-height: 21px;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}

						em {
							color: #6b7687;
							font-size: 13px;
							line-height: 18px;
							margin-top: 2px;
						}

						b {
							display: flex;
							align-items: center;
							justify-content: flex-end;
							padding-right: 8px;
							width: 100%;
							height: 23px;
							color: #fff;
							border-radius: 4px;
							background-color: #6b7687;
							font-size: 15px;
							font-weight: 500;

							&.red {
								background-color: #ef3939;
								color: #fff !important;
							}

							&.green {
								background-color: #1eac4e;
								color: #fff !important;
							}

							&.gray {
								background-color: #6b7687;
								color: #fff !important;
							}
						}
					}
				}
			}
		}

		.dqxhc {
			.text-left {
				text-align: left;
			}

			.text-right {
				text-align: right;
			}

			.text-info {
				color: #aab9d1;
				font-size: 12px;
			}

			.stockTxt {
				margin-top: 10px;
				display: flex;
				align-items: center;

				.stock-code {
					span {
						display: block;
						font-size: 15px;
						color: #e4e9fe;
						font-weight: 500;
					}

					em {
						color: #6b7687;
						font-size: 13px;
						line-height: 18px;
						margin-top: 2px;
					}
				}

				.stock-font {
					color: #e4e9fe;
					font-weight: 500;
					font-size: 16px;
				}

				.stock-price {
					b {
						display: flex;
						align-items: center;
						justify-content: flex-end;
						padding-right: 8px;
						width: 100%;
						height: 23px;
						color: #fff;
						border-radius: 4px;
						background-color: #6b7687;
						font-size: 15px;
						font-weight: 500;

						&.red {
							background-color: #ef3939;
							color: #fff !important;
						}

						&.green {
							background-color: #1eac4e;
							color: #fff !important;
						}

						&.gray {
							background-color: #6b7687;
							color: #fff !important;
						}
					}
				}
			}

			.thead {
				.th {
					&:nth-child(1) {
						flex: 1;
						text-align: left;
					}

					&:nth-child(2) {
						padding-right: 16px;
					}

					&:nth-child(3) {
						flex: 0 0 88px;
					}
				}
			}

			.tbody {
				.tr {
					.td {
						&:nth-child(1) {
							flex: 1;
							text-align: left;
						}

						&:nth-child(2) {
							padding-right: 16px;

							span {
								font-size: 17px;
							}
						}

						&:nth-child(3) {
							flex: 0 0 88px;
						}
					}
				}
			}
		}

		.xhfcjl {
			.table-title {
				color: #aab9d1;
				font-size: 12px;
				margin-top: 12px;
				margin-bottom: 14px;

				.table-title-mid {
					text-align: center;
				}

				.table-title-rigth {
					text-align: right;
				}
			}

			.van-row--flex {
				align-items: center;
			}

			.division_info {
				margin: 14px auto;
				color: #0c0f13;
				border-color: #0c0f13;
			}

			.table-content {
				.date {
					color: #aab9d1;

					span {
						width: 100%;
						display: inline-block;
						font-size: 12px;
					}
				}

				.stock-info {
					color: #aab9d1;

					.stock-info-title {
						font-weight: 500;
						color: #e4e9fe;
						font-size: 15px;
					}

					span {
						width: 100%;
						display: inline-block;
					}

					em {
						color: #6b7687;
						font-size: 12px;
					}
				}

				.table-content-mid {
					text-align: center;
				}

				.table-tag {
					font-size: 13px;
					padding: 2px 8px;
					border-radius: 4px;
				}

				.green-background {
					background: #17341c;
					color: #1eac4e;
				}

				.red-background {
					background: #3b2520;
					color: #ef3939;
				}

				.table-price {
					font-size: 16px;
					text-align: right;
					color: #e4e9fe;
					display: inline-block;
					width: 100%;
				}
			}

			.table-reason {
				line-height: 20px;
				margin-top: 8px;
				position: relative;

				.reason-img {
					width: 56px;
					// height: 20px;
					margin-right: 6px;
					margin-top: 4px;
					float: left;
				}

				.reason-desc {
					color: #e4e9fe;
					font-size: 14px;
				}

				.reason-desc::after {
					content: '';
					display: table;
					clear: both;
				}

				.link-button {
					font-size: 12px;
					color: #517acd;
					float: right;
					// display: inline-block;
					// border: 1px solid red;
				}
			}

			// 锁
			.lock-info {
				filter: blur(6px);
			}

			.lock {
				height: 35px;
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				justify-content: flex-end;
				align-items: center;
				position: absolute;
				top: calc(50% - 15px);
				right: 10px;

				span {
					background: #272935;
					border: 1px solid #3b85fe;
					border-radius: 88px;
					color: #3b85fe;
					font-size: 12px;
					padding: 4px 14px;
				}
			}
		}

		.icon-lock {
			display: inline-block;
			vertical-align: middle;
			width: 48px;
			height: 31px;
			background: url('../../assets/image/hedging/lock.png') no-repeat;
			background-size: 100% auto;
		}

		.expand {
			color: #6b7687;
			text-align: center;
			font-size: 12px;
			padding: 4px 0;
			margin-top: 10px;
		}

		.clfx {
			padding-top: 12px;

			.info {
				font-size: 13px;
				color: #aab9d1;

				em {
					display: inline-block;
					vertical-align: text-bottom;
				}
			}

			.card {
				padding: 12px 0;

				.item {
					position: relative;
					flex: 1;
					background-color: #1d202d;
					color: #aab9d1;
					border-radius: 6px;
					text-align: center;
					padding: 12px 0;

					&:only-child p {
						/* width: 50%; */
						flex: 0 0 50%;
					}

					&:only-child div:nth-child(2) {
						display: flex;
						flex-wrap: wrap;
					}

					&:nth-child(2) {
						margin-left: 8px;
					}

					.item-list {
						display: flex;
						flex-wrap: wrap;
						padding: 0 20px;

						.item-list-span {
							display: block;
							text-align: left;
						}
					}

					.item-list p {
						padding: 0 10px;
					}

					// &:first-child {
					//   margin-right: 8px;
					// }

					&::before {
						content: '';
						position: absolute;
						bottom: 0;
						right: 0;
						background-repeat: no-repeat;
						background-size: 100% auto;
					}

					&:nth-child(1)::before {
						width: 48px;
						height: 55px;
						background-image: url('../../assets/image/hedging/bx.png');
					}

					&:nth-child(2)::before {
						width: 52px;
						height: 52px;
						background-image: url('../../assets/image/hedging/zq.png');
					}

					b {
						display: inline-block;
						line-height: 1.4;
						font-weight: 500;
						font-size: 28px;
					}

					em {
						font-weight: 500;
						font-size: 14px;
					}

					sup {
						position: absolute;
						top: 11px;
						left: 50%;
						color: #fff;
						font-size: 8px;
						padding: 1px 2px;
						border-radius: 2px;
						transform: translateX(25px);
						white-space: nowrap;
					}

					// &:nth-child(1) sup {
					//   background-color: #1eac4e;
					//   color: #fff !important;
					// }

					// &:nth-child(2) sup {
					//   background-color: #ef3939;
					//   color: #fff !important;
					// }

					.font-green {
						color: #1eac4e !important;
					}

					sup.green {
						background-color: #1eac4e;
						color: #fff !important;
					}

					.font-red {
						color: #ef3939 !important;
					}

					sup.red {
						background-color: #ef3939;
						color: #fff !important;
					}

					.flex-w50 {
						flex: 0 0 50% !important;
						margin-bottom: 8px;
					}

					.flex-w100 {
						flex: 1 !important;
					}
				}
			}

			.hcfx {
				padding: 12px 0;

				.item {
					position: relative;
					flex: 1;
					background-color: #1d202d;
					color: #aab9d1;
					border-radius: 6px;
					text-align: center;
					padding: 12px 0;

					&:first-child {
						margin-right: 8px;
					}

					.label {
						font-size: 12px;
					}

					.value {
						font-size: 22px;
						line-height: 31px;
						margin-top: 2px;
						font-weight: 500;
					}
				}

				// 自选股
				.zxg-row {
					width: 100%;

					.zxg-item {
						height: 75px;
						display: flex;
						flex-direction: column;
						flex-wrap: nowrap;
						justify-content: center;
						align-items: center;
						align-content: center;
						background: #1d202d;
						border-radius: 6px;

						.zxg-title {
							color: #aab9d1;
							font-size: 12px;
						}

						.zxg-value {
							font-size: 22px;
							margin-top: 2px;
						}
					}
				}
			}

			.chart {
				height: 200px;
			}


		}
		.tips {
			padding: 14px 16px;
			font-size: 11px;
			color: #6b7687;
			line-height: 1.6;
			text-align: justify;
			background-color: #0c0f13;
		}
	}

	.fixed-button {
		position: fixed;
		bottom: 0;
		left: 50%;
		width: 100%;
		height: 62px;
		max-width: 750px;
		transform: translateX(-50%);
		display: flex;
		align-items: center;
		padding: 0 16px;
		background-color: #1d202d;

		.rank-btn-log {
			flex: 1;

			::v-deep {
				.van-badge {
					border: 0px;
					background: #ef3939;
					border-radius: 10px 88px 88px 0px;
					color: #ffffff;
					font-size: 11px;
				}

				.van-badge--fixed {
					position: absolute;
					top: 0;
					left: 0;
					right: auto;
					-webkit-transform: translate(0%, -50%);
					-ms-transform: translate(0%, -50%);
					transform: translate(0%, -50%);
					-webkit-transform-origin: 100%;
					-ms-transform-origin: 100%;
					transform-origin: 100%;
				}
			}
		}

		.ds-btn {
			width: 49%;

			::v-deep {
				.van-badge {
					border: 0px;
					background: #ef3939;
					border-radius: 10px 88px 88px 0px;
					color: #ffffff;
					font-size: 11px;
				}

				.van-badge--fixed {
					-webkit-transform: translate(10%, -50%);
					-ms-transform: translate(10%, -50%);
					transform: translate(10%, -50%);
					-webkit-transform-origin: 100%;
					-ms-transform-origin: 100%;
					transform-origin: 100%;
				}
			}
		}

		.join-btn {
			flex: 1;
		}

		.ds-sp-btn {
			min-width: 104px;
		}

		.rank-btn {
			color: #fff !important;
		}

		.join-sp-btn {
			width: 49%;
		}

		.sp-btn-info {
			background-color: #3b85fe;
			color: #fff;
			width: 100%;
		}

		span {
			display: flex;
			align-items: center;
			justify-content: center;
			// flex: 1;
			border: 1px solid #3b85fe;
			color: #3b85fe;
			font-size: 16px;
			height: 38px;
			border-radius: 6px;

			&:nth-child(2) {
				background-color: #3b85fe;
				color: #fff;
				margin-left: 8px;
			}
		}
	}

	// 空数据
	.empty-info {
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-items: center;

		.empty-png {
			width: 72px;
			height: 61px;
			margin: 5px auto;
		}

		.empty-text {
			color: #aab9d1;
		}

		.empty-but {
			color: #286df7;
		}
	}
}

.themeWhite {
	.head {
		.title {
			color: #1d2129 !important;
		}

		.desc {
			color: #373a4d !important;

			.head-desc-but {
				color: #286df7 !important;
			}
		}
	}

	.navget_main {
		color: #1d2129;
	}

	.header_main {
		.tab_switch {
			.tab_switch_text {
				color: #2e3748 !important;
			}

			.switch_active::before {
				background: #1d2129 !important;
			}
		}
	}

	.sticky_header {
		.navg_box {
			//   background: linear-gradient(198.51deg, #4478ff -5%, rgba(239, 242, 250, 1) 95%);
			padding-top: 0;
			background: url('../../assets/image/detail_top.png') top no-repeat,
				linear-gradient(198.51deg, #4478ff -5%, rgba(239, 242, 250, 1) 95%);
			background-size: 100% 170px;

			.bg_box {
				width: 100%;
				height: 100%;
				padding-top: 44px;
			}
		}
	}

	.main {
		background-color: #f2f3f5 !important;

		.dqxhc {
			.text-info {
				color: #949da8;
			}

			.stockTxt {
				.stock-code {
					span {
						color: #1d2129;
					}

					em {
						color: #949da8;
					}
				}

				.stock-font {
					color: #1d2129;
				}

				.stock-price {
					b {
						color: #fff;
						background-color: #6b7687;

						&.red {
							background-color: #ef3939;
							color: #fff !important;
						}

						&.green {
							background-color: #1eac4e;
							color: #fff !important;
						}

						&.gray {
							background-color: #6b7687;
							color: #fff !important;
						}
					}
				}
			}
		}
	}

	.mod {
		background-color: #fff !important;
	}

	.mod-title {
		.mod-but {
			.mod-but-text {
				color: #286df7 !important;
			}
		}
	}

	.mod-hd {
		&::before {
			background-color: #286df7 !important;
		}

		span {
			color: #1d2129 !important;
		}

		em {
			color: #4e5969 !important;
		}
	}

	.table {
		.thead {
			.th {
				color: #949da8 !important;
			}
		}

		.tbody {
			.tr {
				.td {
					span {
						color: #1d2129 !important;
					}

					em {
						color: #949da8 !important;
					}
				}

				.lock {

					// 空 block 也保留，便于未来扩展
					span {
						border-color: #286df7 !important;
						color: #286df7 !important;
						background-color: #fff !important;
					}
				}
			}
		}
	}

	.xhfcjl {
		.table-title {
			color: #949da8;
		}

		.table-content {
			.date {
				color: #4e5969 !important;
			}

			.stock-info {
				.stock-info-title {
					color: #1d2129 !important;
				}

				em {
					color: #949da8 !important;
				}
			}

			.green-background {
				background: #e8ffec !important;
				color: #1eac4e !important;
			}

			.red-background {
				background: #ffece8 !important;
				color: #ef3939 !important;
			}

			.table-price {
				color: #1d2129 !important;
			}
		}

		.table-reason {
			.reason-desc {
				color: #1d2129 !important;

				.link-button {
					color: #7ea7fa !important;
				}
			}
		}

		.lock {
			span {
				background: #ffffff !important;
				border: 1px solid #286df7 !important;
			}
		}

		.division_info {
			color: #e5e5e5 !important;
			border-color: #e5e5e5 !important;
		}
	}

	.expand {
		color: #949da8 !important;
	}

	.clfx {
		.info {
			color: #4e5969 !important;
		}

		.card {
			.item {
				background-color: #f7f8fa !important;
				color: #4e5969 !important;
			}
		}

		.hcfx {
			.item {
				background-color: #f7f8fa !important;

				.label {
					color: #4e5969 !important;
				}
			}

			// 自选股
			.zxg-row {
				.zxg-item {
					background: #f7f8fa !important;

					.zxg-title {
						color: #4e5969 !important;
					}
				}
			}
		}


	}

	.tips {
		color: #949da8 !important;
		background-color: #fff !important;

	}



	.fixed-button {
		background-color: #fff !important;

		.rank-btn {
			background: #eef6ff;
			color: #000000 !important;
		}

		span {
			border-color: #286df7 !important;
			color: #286df7 !important;

			&:nth-child(2) {
				background-color: #286df7 !important;
			}
		}
	}

	// 空数据
	.empty-info {
		.empty-text {
			color: #4e5969;
		}
	}
}
</style>
